import { render } from "./Chat.vue?vue&type=template&id=d892ba84&scoped=true&ts=true"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=d892ba84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d892ba84"]])

export default __exports__